import { render } from "./Skills.vue?vue&type=template&id=9d33a3ce&scoped=true"
import script from "./Skills.vue?vue&type=script&lang=ts"
export * from "./Skills.vue?vue&type=script&lang=ts"

import "./Skills.vue?vue&type=style&index=0&id=9d33a3ce&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9d33a3ce"

export default script